import { BaseViewModel } from "@/models/core/BaseViewModel";

export class HotelSea extends BaseViewModel {
  id: number;
  name: string;
}
